import {
  Component,
  Input,
  ChangeDetectionStrategy,
  ViewEncapsulation,
} from '@angular/core';

import { XuxInputDateComponent } from '@geniuspos/ui-shared/modules/xdm-shared-components/components/xux-input-date';

import { IFieldPreferences } from '@app/shared/types';

@Component({
  selector: 'xux-xvi-input-date',
  templateUrl: './xvi-input-date.component.html',
  styleUrls: ['./xvi-input-date.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XuxXVIInputDateComponent extends XuxInputDateComponent {
  @Input() public field: IFieldPreferences = {};
}
